import gtag, { install } from "ga-gtag";
import mixpanel, { Dict } from "mixpanel-browser";
import TagManager from "react-gtm-module";
import { Environment } from "@core/config/environment";
import { CurrentProfileService } from "@domain/currentProfile/currentProfileService";
import { TrackingService } from "./trackingService";

const tagManagerArgs = {
	gtmId: process.env.GTM_ID ?? "",
};
export class WebTrackingService implements TrackingService {
	private readonly mixpanelEnabled: boolean;

	constructor(currentProfileService: CurrentProfileService) {
		this.mixpanelEnabled = Boolean(Environment.MIXPANEL_TOKEN);

		if (this.mixpanelEnabled) {
			mixpanel.init(Environment.MIXPANEL_TOKEN!, {
				api_host: "https://api-eu.mixpanel.com",
			});
			currentProfileService.currentProfile.onChange((profile) => {
				if (!profile) return;
				mixpanel.identify(String(profile.id));
				mixpanel.people.set({
					$name: profile.primaryName,
					$email: profile.email,
					categories: profile.categories ?? [],
					followeeCount: profile.followeeCount ?? 0,
					memberSince: profile.memberSince ? profile.memberSince.toISOString() : undefined,
				});
			});
		}
		install(process.env.GOOGLE_ANALYTICS_ID, { send_page_view: false });
		TagManager.initialize(tagManagerArgs);
	}

	enableGA(): void {
		install(process.env.GOOGLE_ANALYTICS_ID);
	}

	enableGTM(): void {
		TagManager.initialize(tagManagerArgs);
	}

	enable(value: boolean): void {
		if (!this.mixpanelEnabled) return;
		if (value) {
			mixpanel.opt_in_tracking();
		} else {
			mixpanel.opt_out_tracking();
		}
	}

	isEnabled(): boolean {
		return this.mixpanelEnabled && mixpanel.has_opted_in_tracking();
	}

	time(event: string): void {
		if (!this.mixpanelEnabled) return;
		mixpanel.time_event(event);
	}

	track(event: string, properties?: Dict): void {
		if (this.mixpanelEnabled) {
			mixpanel.track(event, properties);
		}
	}

	updateProfile(id: string, properties: Dict): void {
		if (this.mixpanelEnabled) {
			mixpanel.identify(String(id));
			mixpanel.people.set({ ...properties });
		}
	}

	logPageView = (url: string): void => {
		gtag("config", process.env.GOOGLE_ANALYTICS_ID, { page_path: url });
	};
}
